<template>
  <div class="datatable-outer-container">
    <div class="datatable-main">
      <table class="datatable">
        <thead>
          <tr class="header-row" v-if="!showinheader">
            <th v-if="checkbox">
              <tl-checkbox
                :checked="headcheckbox && (selectrecord.length == tableData.length)"
                @change="(bool)=>{changeHeaderCheckbox(this.headcheckbox= !this.headcheckbox,tableData)}"
              />
              <!-- @change="(bool)=>{this.headcheckbox= !this.headcheckbox}" -->
              <!-- <div class="checkbox">
              <input type="checkbox" value="1" id="checkboxFiveInput">
              </div>-->
            </th>
            <th :style="column.style ? column.style : ''"  v-for="(column, index) in columns" :key="index">{{ column.label }}</th>
            <th class="actions" v-show="showinrow || actionicons"></th>
          </tr>

          <tr class="Editdeleteheader" v-if="showinheader">
            <th :colspan="columns.length">
              <slot name="headercontent" >
                <span>
                  <tl-checkbox :checked="true" />
                </span>
                <span v-for="(icon, index) in icons" :key="index">
                  <img :src="icon.url" @click="()=>{$emit(`${icon.method}`, selectrecord)}" />
                </span>
              </slot>
              <!-- <span><img src="@/assets/garbage.png" @click="deletee(record)"/></span> -->
              <!-- </slot> -->
            </th>
            <th>
              <span>
                <span>{{selectrecord.length}} Selected</span>
                <!-- </th>
                <th v-show="actionbtn">-->
                <span>
                  <button class="export-button" v-show="actionbtn">Action</button>
                </span>
              </span>
            </th>
          </tr>
        </thead>

        <tr
          class="record-row"
          :class="{'selectedRecord': selectedClass}"
          v-for="(record, rowIndex) in activeData"
          :key="rowIndex" 
          @click="rowClicked(record)"
        >
          <td v-if="checkbox">
            <!-- {{selectrecord}} -->
            <!-- <div class="checkbox">
            <input type="checkbox" value="1">
            </div>-->
            <!-- {{record.id}} -->
            <!-- {{selectrecord.length}} -->
            <tl-checkbox
              @change="(bool)=>{changeCheckbox(bool, record)}"
              :checked="headcheckbox || selectrecord.some(item => item.id ==  record.id)"
            />
          </td>
          <td class="row-item" v-for="(column, index) in columns" :key="index">
            <slot
              name="rowcontent"
              v-bind:value="{'record': record, 'column': column, 'index':rowIndex}"
            >
              <p v-show="recordValue(record,column)">
                <!-- editCol != column.key || !selectrecord.includes(record) || record[column.key] == ''"> -->
                {{ record[column.key] }}
              </p>
              <!-- {{editCol == column.key && (selectrecord.indexOf(record)>-1|| showeditCol)}} -->
              <!-- {{record[column.key]}} -->
              <input
                v-if="editCol == column.key && (selectrecord.indexOf(item => item.id == record.id)>-1|| showeditCol)"
                type="text"
                :value="record[column.key]"
                class="inputbox"
                @input="handleinput($event,record)"
              />
            </slot>
          </td>
          <td class="actions align-right" v-if="showinrow">
            <span class="row-container action-img">
              
              <!-- Here add document image and function -->
              <img src="@/assets/document.svg" @click="modalOpen(record)" v-show="showmodal" alt />
              <span class="grey-divider" v-show="(showedit || showdelete || showhistory) && showmodal" />
              <!-- End here -->

              <img src="@/assets/edit.svg" @click="startEditRecord(record)" alt v-show="showedit" />
              <span class="grey-divider" v-show="showedit && showdelete && showDeleteOption(record) " />
              <img
                src="@/assets/delete.svg"
                @click="deleteRecord(record, rowIndex)"
                alt
                v-show="showdelete && showDeleteOption(record)"
              />
              <span class="grey-divider" v-show="(showedit || showdelete) && showhistory" />
              <img src="@/assets/eye-img.svg" @click="history(record)" v-show="showhistory" alt />
            </span>
          </td>
          <td class="actions" v-if="actionicons">
            <span class="row-container action-img" v-for="(icon,index) in actionicons" :key="index">
              <img :src="icon.url" @click="()=>{$emit(`${icon.method}`, record)}" />
              <span class="grey-divider" v-show="index!=(actionicons.length-1)" />
            </span>
          </td>
        </tr>
      </table>
      <!--
    Edit form
      -->
    </div>

    <!-- todo: clean form & pager -->
    <my-form
      v-if="withForm && editMode"
      :fields="columns"
      @cancel="cancel"
      @save="save"
      :data="record"
    />
    <!-- <hr> -->
    <div id="next_button" v-if="showPaging">
      <div v-if="showPrev" class="prev-page-no">
        <span>{{ currentPage - 1 }}</span>
      </div>
      <a v-if="showPrev" class="prev" v-on:click="previousPage">PREV</a>
      <div class="current-page">
        <span>{{ currentPage }}</span>
      </div>
      <a v-if="currentPage < pageCount" class="next" v-on:click="nextPage">NEXT</a>
      <div v-if="currentPage < pageCount" class="prev-page-no">
        <span>{{ currentPage + 1 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
export default {
  name: "DataTable",
  props: {
    columns: {
      type: Array
    },
    tableData: {
      type: Array
    },
    clickAllowed: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    "with-form": {
      type: Boolean,
      default: true
    },
    showPaging: {
      type: Boolean,
      default: false
    },
    disableEdit: {
      type: Boolean,
      default: false
    },
    "disable-delete": {
      type: Boolean,
      default: false
    },
    showinrow: {
      type: Boolean,
      default: true
    },
    showinheader: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Array
    },
    editCol: {
      type: String
    },
    showeditCol: {
      type: Boolean,
      default: false
    },
    // headcheckbox: {
    //   type: Boolean,
    //   default: false
    // },
    search: {
      type: String,
      default: null
    },
    actionbtn: {
      type: Boolean,
      default: false
    },
    actionicons: {
      type: Array
      // default:()=>{return [{url:require('@/assets/edit.svg'), method: 'editStart'},
      //   {url:require('@/assets/delete.svg'), method: 'up'},
      //   {url:require('@/assets/ic-history.svg'), method: 'up'}
      // ]}
    },
    showedit: {
      type: Boolean,
      default: true
    },
    // showadd: {
    //   type: Boolean,
    //   default: false
    // },
    showdelete: {
      type: Boolean,
      default: true
    },
    showhistory: {
      type: Boolean,
      default: true
    },
    showmodal: {
      type: Boolean,
      default: false
    },
    selectedRecord: {
      type: Array,
      default: () => {
        return [];
      }
    },
    deleteCondition: {
      type: Function
    }
  },
  components: {
    "my-form": Form
  },
  data() {
    return {
      editMode: false,
      start: 0,
      count: 10,
      selectedClass: false,
      selectrecord: [],
      record: {},
      headcheckbox: false,
      edit: "edit"
    };
  },
  computed: {
    activeData() {
      let data = this.$_.cloneDeep(this.tableData);
      if (!this.$_.isEmpty(this.search)) {
        data = this.filterData(data, this.search);
      }
      if (this.showPaging) {
        return data.slice(this.start, this.start + this.count);
      } else {
        // //console.log('activeData', data)
        return data;
      }
    },
    setSelectedRecords() {
      if (this.selectedRecord.length) {
        if (this.selectedRecord.length == this.tableData.length) {
          this.headcheckbox = true;
          this.selectedClass = true;
        }
        this.selectrecord = this.selectedRecord;
      } else {
        this.headcheckbox = false;
        this.selectedClass= false;
        this.selectrecord = [];
      }
    },
    currentPage() {
      return Math.floor(this.start / this.count) + 1;
    },
    pageCount() {
      return Math.ceil(this.tableData.length / this.count);
    },
    showPrev() {
      if (this.currentPage == 1) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    setSelectedRecords() {
      if (this.selectedRecord.length) {
        this.selectrecord = this.selectedRecord;
      } else {
        this.selectrecord = [];
        this.headcheckbox = false;
        this.selectedClass = false;
      }
    }
  },
  activated() {
    if (this.selectedRecord.length) {
      if (this.selectedRecord.length == this.tableData.length) {
        this.headcheckbox = true;
        this.selectedClass = true;
      }
      this.selectrecord = this.selectedRecord;
    } else {
      this.selectrecord = [];
      this.headcheckbox = false;
    }
  },
  methods: {
    getUrl(icon) {
      return `@/assets/${icon}`;
    },
    recordValue(rec, col) {
      if (this.showeditCol) {
        return this.editCol != col.key;
      } else {
        return this.editCol != col.key || !this.selectrecord.includes(rec);
      }
    },
    rowClicked(record) {
     // //console.log('inside rowClicked ' + this.clickAllowed);
      if(this.clickAllowed){
          this.$emit('selectedItem', record);
      }
    },
    handleinput(e, record) {
      if (!this.showeditCol) {
        let index = this.selectrecord.findIndex(ele => ele == record);
        this.selectrecord[index][this.editCol] = e.target.value;
        this.$emit("valueChange", this.selectrecord);
      } else {
        record[this.editCol] = e.target.value;
        // //console.log('DT rec', record)
        this.$emit("valueChange", record);
      }
      //  //console.log('value change', this.selectrecord)
    },
    computeClass(record) {
      let result = this.selectrecord.some(function(value) {
        // //console.log('value', value==record)
        return value == record;
      });
      if (this.headcheckbox) {
        // this.selectrecord = this.tableData;
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    changeCheckbox(bool, record) {
      if (bool) {
        this.selectrecord.push(record);
      } else {
        let index = this.selectrecord.findIndex(item => item.id === record.id);
        if(index > -1){
          this.selectrecord.splice(index,1);
        }
        this.$emit("onDeselect", record);
      }
      if (!this.selectrecord.length) {
        this.selectedClass = false;
        this.headcheckbox = false;
      }
      if (this.selectrecord.length == this.tableData.length) {
        this.headcheckbox = true;
        this.selectedClass = true;
      }else{
        this.headcheckbox = false;
        this.selectedClass = false;
      }
      this.$emit("selected", this.selectrecord);
    },

    changeHeaderCheckbox(bool, tableData) {
      if (bool) {
        this.selectedClass = true;
        Object.assign(this.selectrecord,tableData)
      } else {
        this.selectedClass = false;
        this.selectrecord = [];
      }
      this.$emit("headerSelection",bool, this.selectrecord);
    },

    startEditRecord(record) {
      if (!this.disableEdit) {
        this.editMode = true;
        this.record = record;
        this.$emit("editStart", record);
      } else {
        //console.log("editstart", this.disableEdit);
      }
    },

    deleteRecord(record, index) {
      this.$emit("delete", record);
      let obj={record:record, index:index};
      this.$emit("deleteByIndex", obj);
    },
    history(record) {
      this.record = record;
      this.$emit("history", record);
    },
    cancel() {
      this.editMode = false;
      this.$emit("editCancelled");
      this.$emit("editCompleted", false);
    },
    save(record) {
      this.editMode = false;
      this.$emit("editCompleted", true);
      this.$emit("update", record);
    },
    nextPage() {
      this.start += this.count;
    },
    previousPage() {
      this.start -= this.count;
    },
    filterData(data, searchText) {
      let vm = this;
      let index;
      if (data) {
        return data.filter(item => {
          for (index in vm.columns) {
            if (item[vm.columns[index].key]) {
              let match =
                item[vm.columns[index].key]
                  .toString()
                  .toLocaleLowerCase()
                  .indexOf(searchText.toLocaleLowerCase()) > -1;
              if (match) return true;
            }
          }
          return false;
        });
      } else {
        return [];
      }
    },
    showDeleteOption(record) {
      if (!this.deleteCondition) {
        return true;
      }
      return this.deleteCondition(record);
    },

    // Here add new function Modal
    modalOpen(record) {
      this.$emit("modalShow", record);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/tl-datatable.scss";
.inputbox {
  width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
}
.checkbox-width {
  width: 1%;
}
// .export-button {
//     width: 70px;
//     height: 25px;
//     border-radius: 4px;
//     font-family: Montserrat;
//     font-size: 12px;
//     text-align: center;
//     border: 1px solid #5d409f;
//     color: #5d409f;
// }
tr.record-row:hover {
    background: #ebf9f8;
}
.add-icon-table {
  text-align: left;
  display: block;
}
</style>
